module.exports = __webpack_public_path__ + "img/info-land.109a02c5.png";